
import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';

@Component
export default class LeadRejectDialog extends Vue {
  @Prop(Boolean) readonly value!: boolean;

  dialog = false
  valid = false
  loading = false

  notes: string | null = null;

  @Watch('value')
  onValueChange(val: boolean) {
    if (val === true) {
      this.notes = null;
    }

    this.dialog = val;
  }

  @Watch('dialog')
  onDialogChange(val: boolean) {
    if (val === true) {
      this.$nextTick(() => {
        if (this.form) this.form.reset();
      });
    }

    if (this.value !== val) {
      this.$emit('input', val);
    }
  }

  get form(): Vue & { validate: () => boolean; reset: () => boolean } {
    return this.$refs.form as Vue & {
      validate: () => boolean;
      reset: () => boolean;
    };
  }

  onCancel() {
    this.dialog = false;
  }

  async onReject() {
    if (this.form.validate()) {
      this.loading = true;

      await this.$store.dispatch('rejectLead', {
        notes: this.notes,
      });

      this.dialog = false;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    }
  }
}
